export default [{
  path: '/cc-mei',
  component: {
    name: 'ccMeiBase',
    template: '<router-view />',
    meta: {
      resource: 'cc_mei',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'cc_mei-view',
    component: () => import('@/app/cc-mei/CcMeiView.vue'),
    meta: {
      resource: 'cc_mei',
      action: 'read',
      navActiveLink: 'cc_mei-view',
      pageTitle: 'CC MEI',
      breadcrumb: [
        {
          text: 'CC MEI',
          to: { name: 'cc_mei-view' },
          active: true,
        },
      ],
    },
  }],
},
]
